export const SPACES = [
  { key: "all", name: "All spaces", color: "#6366f1" },
  { key: "josh", name: "Josh", color: "#f59e0b", email: "josh@atomip.co.uk" },
  { key: "kyle", name: "Kyle", color: "#06b6d4", email: "kyle@atomip.co.uk" },
  { key: "taya", name: "Taya", color: "#ec4899", email: "georgia@atomip.co.uk" },
  { key: "ollie", name: "Ollie", color: "#10b981", email: "ollie@atomip.co.uk" },
];

export const PEOPLE = SPACES.slice(1);
export const SUPPORT_EMAIL = "support@atomip.co.uk";
const DEFAULT_COLORS = Object.fromEntries(SPACES.map((s) => [s.key, s.color]));
export const applyTeam = (members) => {
  members.forEach((m) => {
    const s = SPACES.find((x) => x.key === m.username);
    if (s) Object.assign(s, { name: m.name, email: m.email, color: m.color || DEFAULT_COLORS[m.username], emoji: m.emoji || "" });
  });
};
export const spaceOf = (key) => SPACES.find((s) => s.key === key) || SPACES[0];
export const spaceParams = (space) => (space === "all" ? {} : { space });
